import { useContext } from 'react';
import { ctxReport } from '@/contexts/ReportCtx';
import MultiDriverSelector from '../common/selection/MultiDriverSelector';

export default function ReportDriverSelector() {
  const reportCtx = useContext(ctxReport);
  if (!reportCtx) return;

  return (
    <MultiDriverSelector
      selectedDrivers={reportCtx.selectedDrivers}
      setSelectedDrivers={reportCtx.setSelectedDrivers}
      searchText={reportCtx.searchText}
      setSearchText={reportCtx.setSearchText}
      maxElementNumber={reportCtx.maxTargetNumber}
    />
  );
}
